<template>
	<Modal
		:title="title"
		:hasCloseBtn="false"
		:closeOnOverlayClick="false"
		:visible="visible"
		:portalOrder="portalOrder"
	>
		<template v-slot:body>
			<div class="update-processing">
				<div class="update-processing-message">
					<div class="update-processing-message__regular">
						<slot name="message">
							{{ message }}
						</slot>
					</div>
					<div class="update-processing-message__bold">
						<slot name="warning">
							{{ warning }}
						</slot>
					</div>
				</div>

				<Loader
					class="update-processing__loader"
					:visible="visible"
					variant="circle"
				/>

				<div class="update-processing__emphasized">
					<slot name="updatingMessage">
						{{ updatingMessage }}
					</slot>
				</div>
			</div>
		</template>
	</Modal>
</template>

<script>
import Modal from '@/components/shells/modal/modal.vue';
import Loader from '@/components/visual/loader/loader.vue';

export default {
	name: 'OpCodesUpdatingModal',
	components: {
		Modal,
		Loader
	},
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		title: {
			type: String,
			default: 'Update Processing'
		},
		message: {
			type: String,
			default:
				'Data is currently being updated. Please wait to view information after changes are finished updating.'
		},
		warning: {
			type: String,
			default: 'Do not leave or reload page.'
		},
		updatingMessage: {
			type: String,
			default: 'Updating'
		},
		portalOrder: {
			type: Number,
			default: 2
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/scss';
.update-processing {
	width: 430px;
	display: flex;
	flex-direction: column;
	gap: $gutter-xl;

	&__emphasized {
		@include heading('md');
		text-align: center;
		margin-bottom: $gutter-md;
	}
}
.update-processing-message {
	font-size: $txt-font-size;
	text-align: center;
	margin-top: $gutter-md;

	&__bold {
		margin-top: $gutter-sm;
		font-weight: $bold-font-weight;
	}
}
</style>
